import lazyLoad from '@loadable/component'

import createPlugin from './createPlugin'

import MapRenderer from './Renderer/MapRenderer'

const mapPlugin = settings =>
    createPlugin({
        Renderer: MapRenderer,
        ...settings,
    })

const map = mapPlugin()
export default map

export { mapPlugin, MapRenderer }
